import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * LoadingOverlay Component
 * Overlays a semi-transparent background with a spinner over its container.
 * 
 * @param {boolean} loading - Whether to show the overlay.
 * @param {string} message - Optional loading message.
 */
const LoadingOverlay = ({ loading, message = "Loading..." }) => {
    if (!loading) return null;

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.6)', // Lighter background
                backdropFilter: 'blur(8px)', // Stronger blur for glass effect
                zIndex: 1050, // Bootstrap modal is 1055, sticky top is 1020
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 'inherit', // Inherit border radius from parent
                transition: 'all 0.3s ease-in-out',
            }}
        >
            <style>
                {`
                    @keyframes pulse-ring {
                        0% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.7); }
                        70% { transform: scale(1); box-shadow: 0 0 0 20px rgba(13, 110, 253, 0); }
                        100% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(13, 110, 253, 0); }
                    }
                    @keyframes float {
                        0% { transform: translateY(0px); }
                        50% { transform: translateY(-5px); }
                        100% { transform: translateY(0px); }
                    }
                `}
            </style>

            <div style={{ position: 'relative' }}>
                {/* Pulsing Circle */}
                <div
                    style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        backgroundColor: '#0d6efd',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '0 4px 15px rgba(13, 110, 253, 0.3)',
                        animation: 'pulse-ring 2s infinite',
                    }}
                >
                    {/* Inner Icon or Dot */}
                    <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: 'white' }}></div>
                </div>
            </div>

            <div
                className="mt-4 fw-bold text-primary"
                style={{
                    letterSpacing: '1px',
                    fontSize: '1rem',
                    animation: 'float 3s ease-in-out infinite'
                }}
            >
                {message}
            </div>
        </div>
    );
};

export default LoadingOverlay;
